(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-video-gallery-carousel').each(function () {
			const carousel = $(this);
			const layout = carousel.data('layout');
			const sliderEl = $('.swiper', carousel)[0];
			const navParent = $('.js-video-gallery-carousel-nav', carousel).parent();

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 1,
				loop: false,
				autoHeight: true,
				effect: layout === 'slider' ? 'slide' : 'fade',

				pagination: {
					el: $('.js-carousel-nav-pagination', carousel)[0],
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="carousel-nav__bullet ' + className + '">' + (index + 1) + '</span>';
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				breakpoints: {
					744: {
						slidesPerView: layout === 'slider' ? 2 : 1,
						spaceBetween: 30,
					},
					1280: {
						slidesPerView: layout === 'slider' ? 2 : 1,
						spaceBetween: 40,
					},
				},
			});
		});
	});
})(jQuery, document, window);